export default "__VITE_ASSET__CXWgcgNp__"